<template>
  <div>
    <a @click="userViewRouter(row)" title="View User">
      <i class="material-icons">remove_red_eye</i>
    </a>

    <a @click="toggleBlock(row)" v-if="row.is_blocked" title="Activate User">
      <i class="material-icons">check_circle</i>
    </a>
    <a @click="toggleBlock(row)" v-else title="Deactivate User">
      <i class="material-icons">pause_circle_filled</i>
    </a>
    <a
      @click="businessAddRouter(row)"
      v-if="!row.business"
      title="Add Business"
    >
      <i class="material-icons">restaurant</i>
    </a>
  </div>
</template>
<script>
import * as firebase from "firebase";

export default {
  props: ["row", "nested"],
  methods: {

    // Go to business add
    businessAddRouter(user) {
      this.$router.push({ name: "BusinessAdd", params: { userKey: user.key } });
    },

    // Go to user view
    userViewRouter(user) {
      this.$router.push({ name: "UserView", params: { userKey: user.key } });
    },

    toggleBlock(item) {
      firebase
        .database()
        .ref("users/" + item.key)
        .update({ is_blocked: !item.is_blocked })
        .then(() => {
          this.$bus.$emit("toggleUserBlock", item);
        })
        //.catch((error) => {});
    },
  },
};
</script>
<style scoped>
a {
  cursor: pointer;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Operations/UserOpt.vue